export default __webpack_public_path__ + "static/media/cloud-loading.26a4669f.gif";